var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./swiper.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-02ca69b6\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../vue-loader/lib/selector?type=template&index=0!./swiper.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome-swiper/src/swiper.vue
// module id = 957
// module chunks = 1